import { reportComment } from '../../../actions/report-comment';

export const reportCommentModalResolver = report => reportComment(report);
